import { Immutable } from "immer";
import React from "react";
import { getSpacingClasses } from "tsi-common-react/src/components/_spacing/spacing";

import type { DetailBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

type Props = Immutable<{
    value: Value;
}>;

export const DetailBlock = (props: Props): React.JSX.Element | null => {
    const v = props.value;
    const showHeading = !v.hide_heading && !!v.heading;
    const details = v.details ?? [];
    return (
        <section
            className={concatClassNames([
                "detail",
                v.background_style ?? "",
                v.spacing ? getSpacingClasses(v.spacing) : "",
            ])}
        >
            {showHeading && (
                <header>
                    <RichTextBlock value={v.heading ?? ""} />
                </header>
            )}
            {details.map((item, i) => (
                <RichTextBlock key={i} value={item ?? ""} />
            ))}
        </section>
    );
};
